import { FlagIcon } from "@components:flags/FlagIcon";
import { Box, SxProps, Typography } from "@mui/material";
import { DocumentTypeIcon } from "@pages:app/document-translation/components/DocumentTypeIcon";
import { TranslatedFileInfo } from "@pages:app/document-translation/types";
import { formatFileSize } from "@pages:app/document-translation/utils/fileHelpers";
import { getFlagCodeFromLanguage } from "@pages:app/document-translation/utils/language";
import { useTranslation } from "react-i18next";

export const FileCard = ({
  filename,
  size,
  sx,
  language,
}: Partial<TranslatedFileInfo> & { sx?: SxProps; language?: string }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 480,
        background: "linear-gradient(135deg, #f8f8f8 0%, #f0f0f0 100%)",
        borderRadius: "16px",
        padding: "20px",
        mb: "24px",
        display: "flex",
        alignItems: "center",
        textAlign: "left",
        animation: "fadeInUp 0.5s ease-out 0.5s both",
        ...sx,
      }}
    >
      <Box sx={{ mr: 2, flexShrink: 0 }}>
        <DocumentTypeIcon size="small" filename={filename} />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            color: "#1D1D1D",
            fontSize: "15px",
            fontWeight: 600,
            mb: "6px",
            wordBreak: "break-word",
          }}
        >
          {filename}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "#666468",
            fontSize: "13px",
          }}
        >
          <Typography component="span" sx={{ fontSize: "inherit" }}>
            {formatFileSize(size, t)}
          </Typography>
          {language && (
            <>
              <Typography component="span" sx={{ fontSize: "inherit" }}>
                •
              </Typography>
              <Typography
                component="span"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: "inherit",
                }}
              >
                {t("translation.translateInto")}
                <FlagIcon
                  code={getFlagCodeFromLanguage(language)}
                  title={t(`translation.languages.${language}`)}
                  style={{
                    width: "16px",
                    height: "16px",
                    display: "inline-block",
                  }}
                />
                {t(`translation.languages.${language}`)}
              </Typography>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};
